const allprojectcat = { data: [], loading: true };
export const GetAllProjectCatReducer = (state = allprojectcat, action) => {
  switch (action.type) {
    case "get_allprojectcat":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
